import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { InAppBrowser, UrlEvent } from '@capgo/inappbrowser';
import { AlertController, ModalController, Platform } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { LocationService } from 'src/app/services/location/location.service';
import { PaymentService } from 'src/app/services/payment/payment.service';
import { AppConfig } from 'src/app/variables';
import { version as appVersion } from 'src/app/version';

@Component({
  selector: 'sc-verify-payment',
  templateUrl: './verify-payment.component.html',
  styleUrls: ['./verify-payment.component.scss']
})
export class VerifyPaymentComponent implements OnInit {
  url: SafeResourceUrl;
  currency: string = 'NOK';
  loading: boolean = true;
  @Input() nonce: string;
  @Input() bin: string;
  btToken: string;
  @Input() paymentMethodID: any;
  success: boolean = false;
  appConfig: AppConfig = new AppConfig();
  appVersion: string = appVersion;
  constructor(
    private sanitizer: DomSanitizer,
    private payment: PaymentService,
    private locationService: LocationService,
    private modalCtrl: ModalController,
    private translate: TranslateService,
    private alertCtrl: AlertController,
    private platform: Platform
  ) {}

  ngOnInit() {
    this.locationService.getCountry().then(
      (country) => {
        this.currency = country.CurrencyCode;
        this.init(country.CurrencyCode);
      },
      (err) => {
        this.init('NOK'); //Fallback when everything else fails.
      }
    );
  }

  init(currency) {
    this.loading = true;
    this.payment.getToken(currency).then((btToken) => {
      let key = {
        btToken: btToken,
        nonce: this.nonce,
        bin: this.bin,
        paymentID: this.paymentMethodID,
        errorHeader: this.translate.instant('VERIFY_CARD.COULD_NOT_VERIFY'),
        errorText:
          this.translate.instant('VERIFY_CARD.COULD_NOT_VERIFY_DETAILS') +
          ' ' +
          this.translate.instant('APP.TRY_AGAIN_OR_SUPPORT')
      };

      let token = encodeURIComponent(btoa(JSON.stringify(key)));
      //https://app.smartcharge.io

      let root = this.appConfig.root || 'https://app.smartcharge.io';
      //this.url = this.sanitizer.bypassSecurityTrustResourceUrl(root+"/#/frame/verify-payment/"+token+"?v="+appVersion);
      if (this.platform.is('capacitor') && this.platform.is('ios')) {
        //Use browser for ios since there can be blocking issues with iframe security.
        //TODO: Need to use a generic solution.
        this.setupBrowser(token);
      } else {
        this.setupIframe(token);
      }
    });
  }
  setupIframe(token) {
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(
      'https://pay.current.eco/#/verify-payment/' + token + '?v=' + this.appVersion
    );
    window.onmessage = (e) => {
      if (e.data) {
        if (e.data.authID && e.data.nonce) {
          this.url = null;
          this.registerAuthId(e.data.authID, e.data.nonce);
        } else if (e.data.cancelled) {
          //Close modal
          this.url = null;
          this.modalCtrl.dismiss();
        } else if (e.data.dropinError) {
          this.url = null;
          this.loading = false;
          console.log(e.data.error);
          this.showError(this.translate.instant('VERIFY_CARD.' + e.data.errorCode));
        }
      }
    };
  }
  async setupBrowser(token) {
    await InAppBrowser.removeAllListeners();
    await InAppBrowser.addListener('urlChangeEvent', (event: UrlEvent) => {
      if (event.url.indexOf('callback') != -1) {
        this.modalCtrl.dismiss(true);
        InAppBrowser.close();
      }
    });

    await InAppBrowser.openWebView({
      url:
        // 'https://apptestingaccount.z16.web.core.windows.net/#/verify-payment/' +
        'https://pay.current.eco/#/verify-payment/' + token + '?v=' + this.appVersion + '&iab=true',
      disableGoBackOnNativeApplication: true,
      title: ''
    });
  }
  close() {
    this.modalCtrl.dismiss();
  }
  showError(message) {
    this.loading = false;
    this.alertCtrl
      .create({
        header: this.translate.instant('VERIFY_CARD.COULD_NOT_VERIFY'),
        message: message + ' ' + this.translate.instant('APP.TRY_AGAIN_OR_SUPPORT'),
        buttons: [
          {
            text: this.translate.instant('APP.CANCEL'),
            role: 'cancel',
            handler: () => {
              this.modalCtrl.dismiss();
            }
          },
          {
            text: this.translate.instant('APP.TRY_AGAIN'),
            handler: () => {
              this.init(this.currency);
            }
          }
        ]
      })
      .then((alert) => {
        alert.present();
      });
  }
  registerAuthId(authID, nonce) {
    this.payment.registerAuthID(authID, this.paymentMethodID, nonce).then(
      (res) => {
        this.success = true;
        setTimeout(() => {
          this.modalCtrl.dismiss(true);
        }, 2000);
      },
      (err) => {
        this.loading = false;
        this.showError(this.translate.instant('VERIFY_CARD.COULD_NOT_VERIFY_DETAILS'));
        console.log(err);
      }
    );
  }
  onError(e) {
    console.log(e);
  }
}
